import { Flex, Text } from '@backstage/ui';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { LogoMark } from './LogoMark';
import styles from './LogoFull.module.css';

export const LogoFull = () => {
  const configApi = useApi(configApiRef);
  const title =
    configApi.getOptionalString('app.title') ?? 'Developing Software';

  return (
    <Flex align="center" gap="2">
      <LogoMark size={30} />
      <Text
        as="span"
        variant="body-medium"
        weight="bold"
        className={styles.wordmark}
      >
        {title}
      </Text>
    </Flex>
  );
};
